import { allocateSeats } from './sainteLague.js';
/**
 * Hur nära ligger ett mandatbyte mellan två partier? Söker minsta röstökning för
 * `gainer` (allt annat lika) som ger `gainer` +1 mandat och `loser` −1 mandat.
 * Testar även scenariot att rösterna flyttas direkt från `loser`.
 */
export function findSeatTransfer(votesInput, opts, gainer, loser, maxSearch = 20000) {
    const base = allocateSeats(votesInput, opts);
    const baseSeats = base.seats;
    const votes = new Map(votesInput.map((p) => [p.party, p.votes]));
    if (!votes.has(gainer) || !votes.has(loser)) {
        throw new Error('Okänt parti i mandatbyte');
    }
    const target = (seats) => (seats[gainer] ?? 0) === (baseSeats[gainer] ?? 0) + 1 &&
        (seats[loser] ?? 0) === (baseSeats[loser] ?? 0) - 1;
    const run = (mutate) => {
        for (let delta = 1; delta <= maxSearch; delta++) {
            const v = new Map(votes);
            mutate(v, delta);
            const seats = allocateSeats([...v].map(([party, n]) => ({ party, votes: n })), opts).seats;
            if (target(seats))
                return { delta, seats };
        }
        return null;
    };
    // Scenario A: gainer får fler röster, ingen annan ändras.
    const addOnly = run((v, delta) => v.set(gainer, (v.get(gainer) ?? 0) + delta));
    // Scenario B: röster flyttas loser -> gainer.
    const switched = run((v, delta) => {
        v.set(gainer, (v.get(gainer) ?? 0) + delta);
        v.set(loser, (v.get(loser) ?? 0) - delta);
    });
    return {
        feasible: addOnly !== null || switched !== null,
        gainer,
        loser,
        votesNeeded: addOnly?.delta ?? Number.POSITIVE_INFINITY,
        votesSwitchedIfFromLoser: switched?.delta ?? Number.POSITIVE_INFINITY,
        baseSeats,
        resultingSeats: switched?.seats ?? addOnly?.seats ?? baseSeats,
    };
}
//# sourceMappingURL=transfer.js.map